import { Type } from 'class-transformer';
import { IsArray, IsDate, IsNumber, IsString, ValidateNested } from 'class-validator';
import { UserDto } from './user.dto';

export class CommentDto {
  @IsNumber()
  id: number;

  @Type(() => UserDto)
  user?: UserDto;

  author?: string;

  commentType?: string;

  content: string;

  @IsDate()
  @Type()
  createdAt: Date;
}

export class CreateCommentDto {
  content: string;
}

export class CreateLeadCommentBulkItemDto {
  @IsNumber()
  leadId: number;

  @IsString()
  content: string;
}

export class CreateLeadCommentsBulkDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CreateLeadCommentBulkItemDto)
  items: CreateLeadCommentBulkItemDto[];
}

export class CreateLeadCommentsBulkResultDto {
  failedIds: number[];
}

export class UpdateCommentDto {
  @IsNumber()
  id: number;

  content: string;
}
